import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MetaTagService } from "../../services/meta-tag.service";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.scss"]
})
export class PageNotFoundComponent implements OnInit {
  wrongRoute: string;
  constructor(private location: Location, private metaSrv: MetaTagService) {}

  ngOnInit(): void {
    this.metaSrv.setPrerenderStatusCode(404);

    if (window.history.state && window.history.state.badURL) {
      this.wrongRoute = window.history.state.badURL;
    } else {
      this.wrongRoute = window.location.href;
    }

    this.location.go("/404");
  }
}
